






























import i18n from '@/i18n';
import { EvaluationEssay } from '@/store/modules/essay/state';
import Vue, { PropType } from 'vue';
import { countWords } from '@/helpers/string';

export const MIN_ESSAY_WORDS = 100;

export interface EssaySendFormEvent {
  title?: string;
  text?: string;
  wordCount: number;
}

export default Vue.extend({
  props: {
    currentEssay: {
      type: Object as PropType<EvaluationEssay>,
      default: () => ({} as EvaluationEssay),
    },
  },
  data() {
    return {
      essay: {
        title: this.currentEssay.title?.toString() || '',
        text: this.currentEssay.text?.toString() || '',
        wordCount: countWords(this.currentEssay.text?.toString() || ''),
      },
      textareaStyle: {
        height: 'auto',
      },
      titleError: false,
    };
  },
  methods: {
    inputHandler() {
      this.textareaStyle.height = 'auto';
      this.textareaStyle.height = `${(this.$refs.textarea as Element).scrollHeight}px`;

      this.essay.wordCount = countWords(this.essay.text);

      this.emitEssay();
    },
    emitEssay() {
      this.titleError = !this.essay.title;

      this.$emit('input', this.essay);
    },
    wordCountMessage() {
      const { wordCount } = this.essay;
      if (wordCount >= MIN_ESSAY_WORDS) return i18n.t('essayWordCountMessage.equalOrOver');
      return i18n.t('essayWordCountMessage.under', { amount: MIN_ESSAY_WORDS - wordCount });
    },
  },
});
